import React from 'react';
import { useKatalFeatureFlag } from 'libs/hooks/useKatalFeatureFlag';
import WorkOrderTaskStepsAntD from './component-antd';
import WorkOrderTaskStepsKatal from './component-katal';
import { RecordType } from '@xbcb/shared-types';
import type { WorkOrder } from '@xbcb/api-gateway-client';

export type WorkOrderTaskStepsProps = {
  record: WorkOrder;
  loading?: boolean;
  // TODO switch to apollo codegen type
  workOrderTask: any;
  workOrderRecordType: RecordType;
};

const WorkOrderTaskSteps = (props: WorkOrderTaskStepsProps): JSX.Element => {
  const useKatal = useKatalFeatureFlag();

  return useKatal ? (
    <WorkOrderTaskStepsKatal {...props} />
  ) : (
    <WorkOrderTaskStepsAntD {...props} />
  );
};

export default WorkOrderTaskSteps;
